module.exports = __webpack_public_path__ + "static/img/23.a8093c2f.jpg";